/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Type_For_SuggestionsInputs */

const en_general_type_for_suggestions = /** @type {(inputs: General_Type_For_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type for suggestions`)
};

const de_general_type_for_suggestions = /** @type {(inputs: General_Type_For_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vorschläge tippen`)
};

/**
* | output |
* | --- |
* | "Type for suggestions" |
*
* @param {General_Type_For_SuggestionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_type_for_suggestions = /** @type {((inputs?: General_Type_For_SuggestionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Type_For_SuggestionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_type_for_suggestions(inputs)
	return de_general_type_for_suggestions(inputs)
});